module.exports = __webpack_public_path__ + "img/_0.991857cf.png";